import LocalizedLink from '@components/Localization/LocalizedLink'
import { KontentImage } from '@components/gassan-ui/Image/KontentImage'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { Container, styledLinkStyle } from '@gassan-ui'
import { cn } from '@lib/cn'
import { CategoryPage } from '@lib/kontent/models/CategoryPage'
import { HomepageCbCategories } from '@lib/kontent/models/HomepageCbCategories'
import { FC } from 'react'

type Props = HomepageCbCategories & {
  items: CategoryPage[]
}

const ContentBlockShopCategories: FC<Props> = ({ title, items }) => {
  return (
    <Container>
      <Heading variant="h2" as="h2" className="mb-6 sm:mb-8 xl:mb-10">
        {title.value}
      </Heading>
      <div
        className={cn(
          'grid grid-cols-2 gap-x-4 gap-y-6',
          'sm:grid-cols-3 sm:gap-y-8',
          'lg:grid-cols-6 lg:gap-y-6',
          'xxl:gap-x-6',
        )}
      >
        {items.map((item, index) => (
          <LocalizedLink href={`/${item.url_slug.value}`} key={index}>
            <a className="group relative overflow-hidden" title={item.title.value}>
              <div className="bg-shade-100">
                <KontentImage
                  src={item.image.value[0]?.url}
                  alt={item.image.value[0]?.description}
                  className={cn('aspect-[5/6]', 'sm:aspect-[5/7]')}
                />
              </div>
              <div
                className={cn(
                  'duration-400 relative bg-shade-100 py-2 transition-[padding] ease-in-out',
                  "before:duration-400 before:absolute before:bottom-0 before:left-0 before:z-0 before:block before:h-full before:w-full before:bg-white before:transition-all before:ease-in-out before:content-[''] group-hover:before:translate-y-full",
                  'sm:py-4',
                  'lg:py-6',
                )}
                data-content
              >
                <span
                  className={cn(
                    'relative max-w-full transition-all delay-100 duration-100 ease-in-out',
                    'duration-250 inline-block w-auto items-center truncate border-b border-current p-0 pb-1 leading-6 text-bigStone outline-none',
                    'opacity-100 transition-opacity duration-100 ease-in-out group-hover:opacity-0',
                    styledLinkStyle,
                  )}
                  data-text
                >
                  {item.title.value}
                </span>
                <span
                  className={cn(
                    'absolute left-6 max-w-[calc(100%-1.5rem)] translate-y-2 opacity-0 transition-all duration-100 ease-in-out',
                    'duration-250 inline-block w-auto items-center truncate border-b border-current p-0 pb-1 leading-6 text-bigStone outline-none',
                    'translate-y-full transform delay-100 group-hover:translate-y-0 group-hover:opacity-100',
                    styledLinkStyle,
                  )}
                  data-hover-text
                >
                  {item.title.value}
                </span>
              </div>
            </a>
          </LocalizedLink>
        ))}
      </div>
    </Container>
  )
}

export default ContentBlockShopCategories
